
export default function CompanyDetailsSection() {
  const companyDetails = [
    {
      label: 'Полное наименование',
      value: 'Индивидуальный предприниматель Костина Елена Владимировна'
    },
    {
      label: 'Юридический адрес',
      value: '108815, Москва, Филимонковское п., Марьино п., Светлый б-р, 13, к. 5, 12'
    },
    {
      label: 'Фактический адрес',
      value: '108815, Москва, Филимонковское п., Марьино п., Светлый б-р, 13, к. 5, 12'
    },
    {
      label: 'Телефон',
      value: '+7 (905) 701-06-31'
    },
    {
      label: 'ИНН',
      value: '772352878242'
    },
    {
      label: 'ОКПО',
      value: '2030133663'
    },
    {
      label: 'ОГРНИП',
      value: '324774600129797'
    },
    {
      label: 'ОКВЭД',
      value: '63.11'
    }
  ];

  const bankingDetails = [
    {
      label: 'Полное наименование банка',
      value: 'Филиал "Центральный" Банка ВТБ (ПАО)'
    },
    {
      label: 'Расчетный счет',
      value: '40802810425130000260'
    },
    {
      label: 'Корр. счет',
      value: '30101810145250000411'
    },
    {
      label: 'БИК',
      value: '044525411'
    }
  ];

  return (
    <section id="company-details" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Реквизиты компании
          </h2>
          <p className="text-lg text-gray-600 font-light">
            Официальная информация о нашей компании
          </p>
        </div>
        
        <div className="space-y-8">
          {/* Основная информация */}
          <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
            <div className="bg-gray-800 px-6 py-4">
              <h3 className="text-xl font-medium text-white">Основная информация</h3>
            </div>
            <div className="divide-y divide-gray-200">
              {companyDetails.map((detail, index) => (
                <div key={index} className="px-6 py-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="font-medium text-gray-900">
                    {detail.label}
                  </div>
                  <div className="md:col-span-2 text-gray-700 font-light">
                    {detail.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Банковские реквизиты */}
          <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
            <div className="bg-gray-800 px-6 py-4">
              <h3 className="text-xl font-medium text-white">Банковские реквизиты</h3>
            </div>
            <div className="divide-y divide-gray-200">
              {bankingDetails.map((detail, index) => (
                <div key={index} className="px-6 py-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="font-medium text-gray-900">
                    {detail.label}
                  </div>
                  <div className="md:col-span-2 text-gray-700 font-light font-mono">
                    {detail.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
